export default {
    addOrRemoveProducts: 'add-or-remove-products',
    createWishlist: 'create-wishlist',
    emailWishlist: 'email-wishlist',
    productRemovedFromDetail: 'product-removed-from-detail',
    wishlistUpdated: 'wishlist-updated',
    wishlistDetailQuantityUpdated: 'wishlist-detail-quantity-updated',
}